import { Card, CardContent } from "@mui/material";
import Text from "@commons/Typography/Text";
import Button from "@commons/Button";
import type { SystemNotification } from "@typings/entities/notifications";
import { formatDate } from "@utils/formatters";
import { translateNotificationDescription } from "@utils/translator/notifications";

interface NotificationCardProps {
  notification: SystemNotification;
  onViewDetails: (notification: SystemNotification) => void;
}

function NotificationCard({
  notification,
  onViewDetails,
}: NotificationCardProps) {
  const translatedDescription = translateNotificationDescription(
    notification.description,
  );

  return (
    <Card className="shadow-sm rounded-lg transition-all hover:shadow-md bg-white">
      <CardContent className="p-4">
        <div className="flex flex-col">
          <Text size="lg" className="font-semibold text-gray-900">
            {notification.title}
          </Text>

          <Text size="sm" className="text-gray-600 line-clamp-2 mt-0.5">
            {translatedDescription}
          </Text>

          <div className="flex justify-between items-center mt-2">
            <Text size="xs" className="text-gray-500">
              {formatDate(notification.createdAt)}
            </Text>

            <Button
              customVariant="secondary"
              size="md"
              onClick={() => onViewDetails(notification)}
              className="normal-case py-2 min-w-[140px]"
            >
              Ver detalhes
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default NotificationCard;
